// Activity logging via API Gateway (POST /v1/account-activity).
// No-op until the backend endpoint is added — logs are non-critical.
export async function logAccountActivity(
  _accountId: string,
  _activityType: string,
  _description: string,
  _metadata: Record<string, unknown> = {},
): Promise<void> {
  // TODO: implement POST /v1/account-activity on api-account-management
}
